import UrlParams from "../UrlParams";

export function useIsDemo() {
  const params = new UrlParams(window.location.search)
  return params.get("demo") === "true"
}